import { useMutation } from "react-query";
import rejectSkuLoan from "../services/rejectSkuLoan";

function useRejectSkuLoan() {
  return useMutation(["reject-sku-loan"], rejectSkuLoan);
}

export default useRejectSkuLoan;
